export const PageNotFound = () => {
 return (
  <div className="flex h-screen justify-center items-center">
   <p className="text-3xl font-bold">404</p>
  </div>
 )
}
